"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AsyncLock = void 0;
/**
* 回调Promise拦截器, 可以当成一个异步标记位使用
*/
var AsyncLock = /** @class */ (function () {
    function AsyncLock() {
        var _this = this;
        this.isInnerOpen = false;
        this.innerPromise = new Promise(function (resolve) {
            _this.completePromise = resolve;
        });
    }
    AsyncLock.prototype.isOpen = function () {
        return this.isInnerOpen;
    };
    /**
     * 打开拦截器，触发对应的回调
     */
    AsyncLock.prototype.open = function () {
        this.isInnerOpen = true;
        this.completePromise(true);
    };
    AsyncLock.prototype.wait = function () {
        return this.innerPromise;
    };
    return AsyncLock;
}());
exports.AsyncLock = AsyncLock;
//# sourceMappingURL=async-lock.js.map